import { Note } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseNoteAction, addOrReplaceCaseNotesAction, deleteCaseNoteAction, setCaseNotesAction } from '../reducers/caseNoteReducer';

export const useCaseNoteActions = () => {

    const dispatch = useAppDispatch();
    
    const addOrReplaceCaseNote = (note: Note) => {
        dispatch(addOrReplaceCaseNoteAction(note));
    }
    const addOrReplaceCaseNotes = (notes: Note[]) => {
        dispatch(addOrReplaceCaseNotesAction(notes));
    }

    const setCaseNotes = (notes: Note[]) => {
        dispatch(setCaseNotesAction(notes));
    }

    const removeCaseNote = (noteId: string) => {
        dispatch(deleteCaseNoteAction(noteId));
    }

    return { addOrReplaceCaseNote, addOrReplaceCaseNotes, setCaseNotes, removeCaseNote };
}
